import type { NoticeType } from "./types";

export type SoundCue = "point" | "nextplayer" | "back" | "bust";

const SOURCES: Record<SoundCue, string> = {
  point: "/audio/point.mp3",
  nextplayer: "/audio/nextplayer.mp3",
  back: "/audio/back.mp3",
  bust: "/audio/bust.mp3",
};

const pools = new Map<SoundCue, HTMLAudioElement[]>();

export function scoreSoundCue(noticeType?: NoticeType): SoundCue {
  return noticeType === "bust" ? "bust" : "point";
}

function getPool(cue: SoundCue) {
  if (typeof Audio === "undefined") return [];
  const existing = pools.get(cue);
  if (existing) return existing;
  const created = Array.from({ length: cue === "point" ? 3 : 2 }, () => {
    const audio = new Audio(SOURCES[cue]);
    audio.preload = "auto";
    return audio;
  });
  pools.set(cue, created);
  return created;
}

export function preloadSounds() {
  (Object.keys(SOURCES) as SoundCue[]).forEach((cue) => {
    getPool(cue).forEach((audio) => audio.load());
  });
}

export function playSound(
  cue: SoundCue,
  enabled: boolean,
  volume = 0.7,
  delayMs = 0,
) {
  if (!enabled || typeof window === "undefined") return;
  const play = () => {
    const pool = getPool(cue);
    const audio = pool.find((item) => item.paused || item.ended) ?? pool[0];
    if (!audio) return;
    try {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = Math.min(1, Math.max(0, volume));
      void audio.play().catch(() => undefined);
    } catch {
      // Audio is progressive enhancement and never blocks scoring.
    }
  };
  if (delayMs > 0) window.setTimeout(play, delayMs);
  else play();
}
